// Format a line item's INNER unit size for display, e.g. 12.5 kg or 500 ml.
// Reads `unit_size_value` (number) + `unit_size_unit` (string) off an order item
// (or product). Returns '' when no usable unit size is present.
export const formatUnitSize = (item) => {
  if (!item) return '';
  const raw = item.unit_size_value;
  const unit = (item.unit_size_unit || '').trim();
  if (raw === null || raw === undefined || raw === '') return '';
  const num = Number(raw);
  const val = Number.isNaN(num) ? String(raw) : String(num);
  return unit ? `${val} ${unit}` : val;
};

// Orderable-pack descriptor. When pack_qty > 1 => "6 × 1 L (6 L)".
// Otherwise falls back to the plain inner unit size, e.g. "1 kg".
export const formatPack = (item) => {
  if (!item) return '';
  const inner = formatUnitSize(item);
  const packQty = Number(item.pack_qty || 1);
  if (packQty <= 1) return inner;
  if (!inner) return `Pack of ${packQty}`;
  const val = Number(item.unit_size_value);
  const unit = (item.unit_size_unit || '').trim();
  if (Number.isNaN(val)) return `Pack of ${packQty} × ${inner}`;
  const totalNum = Math.round(val * packQty * 1000) / 1000;
  const totalStr = unit ? `${totalNum} ${unit}` : String(totalNum);
  return `${packQty} × ${inner} (${totalStr})`;
};

// Short badge label, e.g. "Pack of 6". Empty when the product is a single unit.
export const packLabel = (item) => {
  const packQty = Number(item?.pack_qty || 1);
  return packQty > 1 ? `Pack of ${packQty}` : '';
};

// True when the product is sold in a multi-unit pack.
export const isPack = (item) => Number(item?.pack_qty || 1) > 1;
